<style lang="scss" scoped>
/deep/ .comp-employee-archive-edit-dialog {
    max-width: 640px;
}

.att-label {
    width: 160px;
}

.att-url {
    width: calc(100% - 220px);
}
</style>

<template>
    <div class="comp-employee-archive-edit">
        <el-dialog title="编辑员工档案" custom-class="c-el-dialog comp-employee-archive-edit-dialog"
            :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false">
            <el-form :model="dialogData" :rules="formRules" :ref="formRefName" label-width="100px" size="small">
                <el-col :xs="24">
                    <el-form-item label="身份证号">
                        <el-input class="c-pw100" :value="dialogData.idNumber" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="姓名" prop="name">
                        <el-input class="c-pw100" v-model="dialogData.name" placeholder="请输入姓名" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="手机号" prop="tel">
                        <el-input class="c-pw100" v-model="dialogData.tel" placeholder="请输入手机号" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="运营区域">
                        <el-input class="c-pw100" v-model="dialogData.operationArea" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="职位">
                        <el-input class="c-pw100" v-model="dialogData.position" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="用工类型">
                        <el-input class="c-pw100" v-model="dialogData.employmentType" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="职业技能">
                        <el-input class="c-pw100" v-model="dialogData.skills" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="银行卡号">
                        <el-input class="c-pw100" v-model="dialogData.bankCardNo" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="开户行">
                        <el-input class="c-pw100" v-model="dialogData.bankName" placeholder="选填" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12">
                    <el-form-item label="合同到期">
                        <el-date-picker class="c-pw100" v-model="dialogData.contractExpireDate" type="date"
                            placeholder="选填" value-format="yyyy-MM-dd" :clearable="true"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="附件">
                        <div v-for="(item, index) in dialogData.attachments" :key="'att-' + index" class="mrgb5">
                            <el-input class="att-label mrgr5" v-model="item.label" size="small"
                                placeholder="附件名称（如：身份证照）"></el-input>
                            <el-input class="att-url mrgr5" v-model="item.url" size="small"
                                placeholder="附件地址 URL"></el-input>
                            <el-button type="danger" plain size="small" icon="el-icon-delete"
                                @click="dialogData.attachments.splice(index, 1)"></el-button>
                        </div>
                        <el-button type="primary" plain size="small" icon="el-icon-plus"
                            @click="dialogData.attachments.push({ label: '', url: '' })">添加附件</el-button>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="备注">
                        <el-input class="c-pw100" type="textarea" :rows="2" v-model="dialogData.remark"
                            placeholder="选填"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="_close()">取消</el-button>
                <el-button size="small" type="primary" @click="_save()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "compEmployeeArchiveEdit",
    data() {
        return {
            showDialog: false,
            defaultDialogData: {
                id: null,
                idNumber: "",
                name: "",
                tel: "",
                operationArea: "",
                position: "",
                employmentType: "",
                skills: "",
                bankCardNo: "",
                bankName: "",
                contractExpireDate: "",
                attachments: [],
                remark: ""
            },
            dialogData: {},
            formRefName: "refEmployeeArchiveEdit",
            formRules: {
                name: [{ required: true, message: "请输入姓名", trigger: ["blur"] }],
                tel: [
                    { required: true, message: "请输入手机号", trigger: ["blur"] },
                    { pattern: /^\d{11}$/, message: "手机号格式不正确", trigger: ["blur"] }
                ]
            }
        }
    },
    methods: {
        open(row) {
            this.dialogData = JSON.parse(JSON.stringify(this.defaultDialogData))
            if (row && row.id) {
                this.dialogData.id = row.id
                this.dialogData.idNumber = row.idNumber
                this.dialogData.name = row.name
                this.dialogData.tel = row.tel
                this.dialogData.operationArea = row.operationArea || ""
                this.dialogData.position = row.position || ""
                this.dialogData.employmentType = row.employmentType || ""
                this.dialogData.skills = row.skills || ""
                this.dialogData.bankCardNo = row.bankCardNo || ""
                this.dialogData.bankName = row.bankName || ""
                this.dialogData.contractExpireDate = row.contractExpireDate ? moment(row.contractExpireDate).format("YYYY-MM-DD") : ""
                this.dialogData.attachments = (row.attachments || []).map(x => {
                    return { label: x.label, url: x.url }
                })
                this.dialogData.remark = row.remark || ""
            }
            this.showDialog = true
        },
        _save() {
            this.$refs[this.formRefName].validate(valid => {
                if (valid) {
                    window.$common.fullLoading()
                    funEmployee.UpdateEmployeeArchive({
                        id: this.dialogData.id,
                        name: this.dialogData.name.trim(),
                        tel: this.dialogData.tel.trim(),
                        operationArea: this.dialogData.operationArea,
                        position: this.dialogData.position,
                        employmentType: this.dialogData.employmentType,
                        skills: this.dialogData.skills,
                        bankCardNo: this.dialogData.bankCardNo,
                        bankName: this.dialogData.bankName,
                        contractExpireDate: this.dialogData.contractExpireDate || null,
                        attachments: this.dialogData.attachments.filter(x => x.label || x.url),
                        remark: this.dialogData.remark
                    }).then(() => {
                        this.commonSuccess()
                    })
                }
            })
        },
        _close() {
            this.showDialog = false
            this.$nextTick(() => {
                if (this.$refs[this.formRefName]) {
                    this.$refs[this.formRefName].resetFields()
                }
            })
        },
        commonSuccess(val) {
            this.alert(val || "操作成功!").then(() => {
                window.$common.closeFullLoading()
                this._close()
                this.refreshData()
            })
        },
        refreshData() {
            this.$emit("refreshData", this.dialogData)
        }
    }
}
</script>
